import React, { useMemo } from 'react';
import GeoBrandCoverageChart from './GeoBrandCoverageChart';
import GeoInsightsKpiColumn from './GeoInsightsKpiColumn';
import GeoBrandRankingTable from './GeoBrandRankingTable';
import GeoBrandVisibilityIndex from './GeoBrandVisibilityIndex';
import GeoTopPromptsTable from './GeoTopPromptsTable';
import GeoCitationsChart from './GeoCitationsChart';
import GeoCitationsTable from './GeoCitationsTable';
import { mapGeoKpiCards } from '../utils/geoPresentation';
import { buildGeoBrandColorMap } from '../utils/geoBrandColors';

/**
 * Insights dashboard body (mirrors SecFilingInsightsSummary composition).
 */
export default function GeoInsightsSummary({
  insights,
  loading = false,
  error = null,
}) {
  const coverage = insights?.brandCoverageOverTime || { labels: [], series: [] };
  const citationsOverTime = insights?.citationsOverTime || { labels: [], values: [] };
  const citations = insights?.citations || { rows: [], totalCitations: 0, uniquePages: 0 };
  const kpiCards = mapGeoKpiCards(insights?.kpiCards || []);
  const brandColorMap = useMemo(
    () => buildGeoBrandColorMap(insights?.brandRanking || []),
    [insights?.brandRanking],
  );

  return (
    <>
      {error ? (
        <p className="assistants-status geo-insights-error" role="alert">
          {error}
          {' '}
          — ensure Prompt Pulse is available.
        </p>
      ) : null}

      <div className="geo-insights-kpi-chart-layout">
        <GeoInsightsKpiColumn
          kpiCards={kpiCards}
          loading={loading}
        />

        <GeoBrandCoverageChart
          labels={coverage.labels}
          series={coverage.series}
          loading={loading}
        />

        <GeoBrandRankingTable
          rows={insights?.brandRanking || []}
          loading={loading}
        />
      </div>

      <GeoBrandVisibilityIndex
        data={insights?.brandVisibilityIndex}
        brandColorMap={brandColorMap}
        loading={loading}
      />

      <GeoTopPromptsTable rows={insights?.topPrompts || []} loading={loading} />

      <div className="geo-insights-citations-layout">
        <GeoCitationsChart
          labels={citationsOverTime.labels}
          values={citationsOverTime.values}
          loading={loading}
        />
        <GeoCitationsTable
          rows={citations.rows}
          totalCitations={citations.totalCitations}
          uniquePages={citations.uniquePages}
          loading={loading}
        />
      </div>
    </>
  );
}
